"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash"));

require("./svg.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * The SVG component leverages the webpack config
 * found in index.js that runs svg-react-loader on all svgs in the svg folder
 *
 * Usage:
 *
 * For core Icon loaded in UI common:
 *  <SVG id='<icon file name>' />
 *  i.e <SVG id='checkmark' />
 *
 * For Contentful objects of type Icon:
 * <SVG core={false} svgAsset={contentfulIconObject} />
 * i.e <SVG core={false} svgAsset={props.globalFooterLogo} />
 *
 * NOTE: The last classname passed will be appended with 'Wrapper'.
 */
var SVG = function SVG(_ref) {
  var id = _ref.id,
      className = _ref.className,
      onClick = _ref.onClick,
      core = _ref.core,
      svgAsset = _ref.svgAsset;
  var svgClassName = (0, _classnames["default"])('icon', id, className, {
    hasClick: onClick
  });
  var wrapperClassName = (0, _classnames["default"])("".concat(className, "Wrapper"));

  if (core) {
    var iconName = id;

    var Icon = require("../svg/".concat(iconName, ".svg")); // eslint-disable-line


    return (
      /*#__PURE__*/
      // Note, the last class name will be appended with 'Wrapper'
      _react["default"].createElement("span", {
        className: wrapperClassName
      }, /*#__PURE__*/_react["default"].createElement(Icon, {
        className: svgClassName,
        onClick: onClick
      }))
    );
  }

  var url = "".concat(_lodash["default"].get(svgAsset, 'fields.file.url'));
  return /*#__PURE__*/_react["default"].createElement(ExternalSVG, {
    className: svgClassName,
    wrapperClass: wrapperClassName,
    onClick: onClick,
    url: url
  });
};

SVG.propTypes = {
  core: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  svgAsset: _propTypes["default"].objectOf(_propTypes["default"].object),
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].func
};
SVG.defaultProps = {
  core: true,
  id: null,
  svgAsset: null,
  className: 'default',
  onClick: null
};
var _default = SVG;
exports["default"] = _default;

var ExternalSVG = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ExternalSVG, _React$PureComponent);

  var _super = _createSuper(ExternalSVG);

  function ExternalSVG(props) {
    var _this;

    _classCallCheck(this, ExternalSVG);

    _this = _super.call(this, props);
    _this.state = {};
    return _this;
  }

  _createClass(ExternalSVG, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          url = _this$props.url,
          className = _this$props.className,
          onClick = _this$props.onClick;
      fetch(url).then(function (response) {
        return response.text();
      }).then(function (svgData) {
        var svgString;

        try {
          var svg = new DOMParser().parseFromString(svgData, 'text/xml').documentElement;
          svg.setAttribute('class', className);
          svg.setAttribute('onClick', onClick);
          svgString = new XMLSerializer().serializeToString(svg);
        } catch (e) {
          svgString = '';
        }

        _this2.setState({
          svgData: svgString
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var wrapperClass = this.props.wrapperClass;
      var svgData = this.state.svgData;
      return /*#__PURE__*/_react["default"].createElement("span", {
        className: wrapperClass,
        dangerouslySetInnerHTML: {
          __html: svgData
        }
      });
    }
  }]);

  return ExternalSVG;
}(_react["default"].PureComponent);

ExternalSVG.propTypes = {
  url: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string.isRequired,
  wrapperClass: _propTypes["default"].string.isRequired,
  onClick: _propTypes["default"].func
};
ExternalSVG.defaultProps = {
  onClick: null
};